import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="bg-white tech-grid-light py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-20" data-mp="22ebwf84sbiga">
      <div className="mx-auto max-w-5xl px-4" data-id="element-21" data-mp="1yfcr3mf55job">
        <div className="text-center" data-id="element-22" data-mp="1aogt27k3ds8m">
          <span className="inline-flex items-center gap-2 rounded-md bg-gold px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-forestDeep" data-id="element-23" data-mp="1apihddq4cb8a">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-24" data-mp="1jgr41r2ta1qx" /> Incluidos sin costo extra
          </span>
          <h2 id="bonus-title" className="mt-4 text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-25" data-mp="1eq2e4g6s5ctw">
            Los {totalBonuses} bonos estratégicos
          </h2>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-26" data-mp="qydf6gzgdq3z">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.article key={bonus.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className={`flex flex-col rounded-xl bg-forest p-6 shadow-card ${bonus.wide ? 'md:col-span-2' : ''}`} data-id="element-27" data-mp="29smmr1xl8psd" data-mpi={index}>
                <div className="flex items-center justify-between gap-4" data-id="element-28" data-mp="1qvbo9jjs60dz">
                  <div className="flex items-center gap-3" data-id="element-29" data-mp="1vstxlb1pmhmi">
                    <span className="flex h-10 w-10 items-center justify-center rounded-md bg-gold text-forestDeep" data-id="element-30" data-mp="20qvhfy6ymkz1">
                      <Icon className="h-5 w-5" aria-hidden="true" data-id="element-31" data-mp="25rj4k8s2ihnz" />
                    </span>
                    <p className="text-[11px] font-extrabold uppercase tracking-[.16em] text-mutedDark" data-id="element-32" data-mp="3c7d4x8skxd9j">
                      Bono {bonus.number}
                    </p>
                  </div>
                  <p className="text-xs font-bold text-mutedDark" data-id="element-33" data-mp="1h2m3vbjnvpyl">
                    <span className="line-through" data-id="element-34" data-mp="1c4atmzpgfdfu">Valor real {bonus.value}</span>
                    <span className="ml-2 rounded-md bg-sage px-2 py-1 text-[11px] font-extrabold uppercase tracking-wide text-white" data-id="element-35" data-mp="1c6et95gblqab">
                      Gratis
                    </span>
                  </p>
                </div>

                <h3 className="mt-4 text-lg font-extrabold leading-tight text-white" data-id="element-36" data-mp="yce493f67hn5">{bonus.title}</h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-mutedDark" data-id="element-37" data-mp="teckeg9x7eam">{bonus.description}</p>

                <p className="mt-4 rounded-lg border-l-4 border-gold bg-gold/15 px-4 py-3 text-sm font-semibold text-onDark" data-id="element-38" data-mp="175he71qlxcd1">
                  {bonus.benefit}
                </p>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-5 rounded-xl border border-gold bg-goldSoft px-6 py-6 text-center sm:flex-row sm:text-left" data-id="element-39" data-mp="endhnlvrnjyy">
          <div data-id="element-40" data-mp="j4ndz67p2hv">
            <p className="text-xs font-extrabold uppercase tracking-[.18em] text-muted" data-id="element-41" data-mp="imm2o4ozy33">
              Valor total de los {totalBonuses} bonos
            </p>
            <p className="mt-1 font-display text-2xl font-extrabold text-ink line-through decoration-danger decoration-2" data-id="element-42" data-mp="3mquwska1crwd">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-43" data-mp="j9w7nvrqmdb1">
            <p className="text-xs font-extrabold uppercase tracking-[.18em] text-muted" data-id="element-44" data-mp="jaxl26w87bvx">Tu precio hoy</p>
            <p className="mt-1 font-display text-3xl font-extrabold text-forestSoft" data-id="element-45" data-mp="o7nyemgnbtdn">GRATIS</p>
          </div>
        </div>

        <p className="mt-4 text-center text-xs font-bold uppercase tracking-[.14em] text-muted" data-id="element-46" data-mp="9bghbv0jb82l">
          Solo incluidos en esta oferta
        </p>
      </div>
    </section>;
}